<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>{{ $route.meta.name }}管理</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $route.meta.name }}列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="row">
      <div class="col-sm-12">
        <div class="panel">
          <div>
            <div class="filter">
              <el-form
                :inline="true"
                :model="filter"
                ref="filterForm"
                label-position="right"
                label-width="80px"
                class="search-form"
                size="small"
              >
                <el-form-item label="仓库" prop="stockroom_id" v-if="!admin">
                  <stockroom-select
                    :clearable="false"
                    :val="filter.stockroom_id"
                    @change="filter.stockroom_id = $event"
                  ></stockroom-select>
                </el-form-item>
                <el-form-item label="复合片" prop="pdc_id">
                  <pdc-select
                    :val="filter.pdc_id"
                    :stockroom_id="filter.stockroom_id"
                    @change="filter.pdc_id = $event"
                  ></pdc-select>
                </el-form-item>
                <el-form-item label="出库时间" prop="date">
                  <el-date-picker
                    clearable
                    v-model="filter.date"
                    type="daterange"
                    size="small"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-form-item>
              </el-form>
              <div style="margin-left: 80px">
                <el-button
                  type="primary"
                  size="small"
                  @click="
                    page = 1
                    getData()
                  "
                  >筛选</el-button
                >
                <el-button size="small" @click="reset()">重置</el-button>
              </div>
            </div>
          </div>
        </div>
        <div class="panel">
          <btn-tag
            v-if="admin"
            :btn="true"
            :text="'添加' + $route.meta.name"
            :auth-id="51201"
            btn-class="btn-purple"
            icon-class="ion-plus-circled"
            module-name="stock"
            @click.native="showFormer"
          ></btn-tag>
          <item-table
            :items="items.list"
            :admin="admin"
            v-loading="loading"
          ></item-table>
          <pagination
            :records="items.count"
            :page="page"
            :per-page="20"
            @paginate="loadData"
          ></pagination>
        </div>
      </div>
    </div>

    <pdc-out-former
      :model="model"
      :show.sync="formerVisible"
      @created="createdCallback"
    ></pdc-out-former>
  </div>
</template>

<script>
import { pdcOutRecordList } from '@/service/getData'
import ItemTable from './table'
import PdcOutFormer from '@/components/pdc_out_former'
import { getStore } from '@/config/mUtils'
import StockroomSelect from '@/components/select/stockroom_select'
import PdcSelect from '@/components/select/pdc_select'

export default {
  components: {
    ItemTable,
    PdcOutFormer,
    StockroomSelect,
    PdcSelect,
  },
  data() {
    return {
      loading: false,
      admin: getStore('userInfo').is_stockroom_admin,
      model: {
        pdc_id: '',
        stock_out_category: 1,
        category: 1,
        number: 1,
        drills: null,
        logistic_company: '',
        logistic_number: '',
        receiver_mobile: '',
        remark: '',
      },
      formerVisible: false,
      page: 1,
      filter: { stockroom_id: 1, pdc_id: '', date: '' },
      items: {
        list: [],
        count: 0,
      },
    }
  },
  created() {
    this.getData()
  },
  methods: {
    reset() {
      this.$refs['filterForm'].resetFields()
      this.page = 1
      this.getData()
    },
    async getData() {
      let data = {
        page: this.page - 1,
        stockroom_id: this.filter.stockroom_id,
        pdc_id: this.filter.pdc_id,
      }
      if (this.filter.date && this.filter.date.length == 2) {
        data.start_date = this.filter.date[0]
        data.end_date = this.filter.date[1]
      }
      this.loading = true
      let res = await pdcOutRecordList(data)
      if (res.status != 0) return false
      this.items = res.data
      this.loading = false
    },
    async loadData(page) {
      this.page = page
      this.getData()
    },
    showFormer() {
      this.formerVisible = true
      this.$nextTick(() => {
        this.model.drills = []
      })
    },
    createdCallback(item) {
      this.items.list.unshift(item)
    },
  },
}
</script>